
import {Component, Vue} from 'vue-property-decorator';
import {readFormCategories} from '@/store/admin/getters';
import {
  dispatchDeleteFormCategory,
  dispatchGetFormCategories,
} from '@/store/admin/actions';
import DynamicTable from '@/components/datatables/DynamicTable.vue';

@Component({
  components: {DynamicTable},
})
export default class FormCategoryList extends Vue {

  private headers = [
    {text: this.$t('action'), value: 'action', align: 'center', filterable: false, sortable: false,
      router_name: 'main-admin-forms-form-category-edit', width: '100px', delete_function: this.deleteFormCategory},
    {
      text: this.$t('name'),
      sortable: true,
      value: 'name',
      align: 'left',
    },
    {
      text: this.$t('description'),
      sortable: false,
      value: 'description',
      align: 'left',
    },
  ];

  get formCategories() {
    return readFormCategories(this.$store);
  }

  public async mounted() {
    await dispatchGetFormCategories(this.$store);
  }

  public async deleteFormCategory(id) {
    await dispatchDeleteFormCategory(this.$store, id);
    await dispatchGetFormCategories(this.$store);
  }

}
